import { Icon, IconName } from "@zapier/zinnia-icons";
import { useInterfacesTheme } from "lib/theme/ThemeProvider";
import { cn } from "utils/cn";

function StyledButton(props: React.ComponentPropsWithoutRef<"button">) {
  const interfacesTheme = useInterfacesTheme();
  return (
    <button
      {...props}
      className={cn(
        "relative h-[50px] w-[50px] cursor-pointer pt-[5px] shadow-[0_5px_10px_0_rgba(0,_0,_0,_0.2)]",
        {
          "rounded-[50%] bg-zi-primary": !interfacesTheme,
          "rounded-full bg-primary": interfacesTheme,
        },
        props.className
      )}
    />
  );
}

function StyledIcon({
  $isIconHidden,
  ...props
}: React.ComponentPropsWithoutRef<"div"> & {
  $isIconHidden: boolean;
}) {
  return (
    <div
      {...props}
      className={cn(
        "absolute left-2.5 top-2.5 transition-transform",
        {
          "scale-0 transform opacity-0": $isIconHidden,
          "scale-100 transform opacity-100": !$isIconHidden,
        },
        props.className
      )}
    />
  );
}

export default function DefaultEmbedIcon({
  isHidden,
  onClickToggleHandler,
  size = 30,
  iconName = "navAIChatbot",
  ...delegated
}: React.ComponentPropsWithoutRef<"button"> & {
  isHidden: boolean;
  onClickToggleHandler: () => void;
  size?: number;
  iconName?: IconName;
}) {
  return (
    <StyledButton
      {...delegated}
      data-hidden={isHidden}
      className={cn("chatbot-icon-button", delegated.className)}
      onClick={onClickToggleHandler}
    >
      <StyledIcon $isIconHidden={!isHidden}>
        <Icon color="PrimeWhite" name={iconName} size={size} />
      </StyledIcon>
      <StyledIcon $isIconHidden={isHidden}>
        <Icon color="PrimeWhite" name="formX" size={size} />
      </StyledIcon>
    </StyledButton>
  );
}
